import { DataGrid, DataGridLayout } from '@verantos-dev/shared-components';

import AccuracyMatrix from './AccuracyMatrix';
import { useAccuracyConceptList } from '../hooks/useAccuracyConceptList';

const DataReliabilityAccuracyPage = () => {
  const {
    accuracyTableColumns,
    gridData,
    openConfusionMatrixDialog,
    setOpenConfusionMatrixDialog,
    selectedConcept,
    setSelectedConcept,
    useFetchDataGridData,
    gridMessages,
  } = useAccuracyConceptList();

  return (
    <>
      <DataGridLayout id="data-reliability-accuracy-layout">
        <DataGrid
          id="concept-list"
          mode="client"
          rows={gridData}
          getRowId={(row) => row.conceptId}
          columns={accuracyTableColumns}
          useFetchDataGridData={useFetchDataGridData}
          getRowCount={(data) => data.pagination.total}
          pageSizeOptions={[10, 25, 50, 100]}
          initialPageSize={100}
          messages={{
            ...gridMessages,
          }}
          pagination
          initialState={{
            sorting: {
              sortModel: [{ field: 'name', sort: 'asc' }],
            },
          }}
          slotProps={{
            columnHeaders: {
              style: {
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                lineHeight: 'normal',
                padding: '16px 24px',
                fontWeight: '500',
                fontSize: '14px',
                color: '#252A36',
              },
            },
          }}
        />
      </DataGridLayout>

      {openConfusionMatrixDialog && (
        <AccuracyMatrix
          selectedConcept={selectedConcept}
          setSelectedConcept={setSelectedConcept}
          setOpenConfusionMatrixDialog={setOpenConfusionMatrixDialog}
        />
      )}
    </>
  );
};
export default DataReliabilityAccuracyPage;
